const injections = require('../../frontend/require-angular-injections.js');

injections.push('linagora.esn.account');

module.exports = injections;
